import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enGlobal from '../locales/en/global.json';
import ptGlobal from '../locales/pt/global.json';
import esGlobal from '../locales/es/global.json';
import enCollabClub from '../locales/en/collab-club.json';
import ptCollabClub from '../locales/pt/collab-club.json';
import esCollabClub from '../locales/es/collab-club.json';
// English only for now; pt/es fall back to en through `fallbackLng`.
import enPublishing from '../locales/en/publishing.json';

export const defaultNS = 'global';

export const supportedLanguages = {
  en: 'English',
  pt: 'Portuguese',
  es: 'Spanish',
};

export function getLangLabel(langKey: string): string {
  return langKey in supportedLanguages
    ? supportedLanguages[langKey as keyof typeof supportedLanguages]
    : '';
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: Object.keys(supportedLanguages),
    debug: true,
    resources: {
      en: {
        global: enGlobal,
        'collab-club': enCollabClub,
        publishing: enPublishing,
      },
      pt: {
        global: ptGlobal,
        'collab-club': ptCollabClub,
      },
      es: {
        global: esGlobal,
        'collab-club': esCollabClub,
      },
    },
    defaultNS,
    // React already escapes rendered text; without this, interpolated names
    // like O'Neil would show HTML entities.
    interpolation: { escapeValue: false },
  });
